import React, { useState } from 'react';

import { useSharedData } from '../Contexts/SharedContext';


import ToiletIcon from '../Elements/Icon/assets/toilet.component.svg';
import ElevatorIcon from '../Elements/Icon/assets/elevator.component.svg';
import ClosetIcon from '../Elements/Icon/assets/closet.component.svg';
import ResturantIcon from '../Elements/Icon/assets/resturant.component.svg';

import Modal from './Modal';
import { getTranslatedValue } from '../Utils/getTranslatedText';

const StartPageMenu = ({ language }) => {
    const [modalData, setModalData] = useState(null);
    const { content, loading, error } = useSharedData();

    const onCloseModal = () => setModalData(null);

    const onMenuItemClick = (Icon, item) => {
        setModalData({
            icon: Icon,
            data: item
        });
    }

    if (!content) {
        return null;
    }
    const menuItems = content.menu?.menuItems ?? [];

    return (
        <>
            <ul className="start-page-menu">
                { menuItems.map((item, idx) => {
                    const type = item.menuItemIcon;
                    const IconComponent = resolveIcon(type);
                    const label = getTranslatedValue(item.menuItemLabel, language);
         
                    return label ? (
                        <li className="start-page-menu__item" key={ idx }>
                            <button 
                                className="start-page-menu__button" 
                                onClick={() => onMenuItemClick(IconComponent, item)} 
                                aria-haspopup="dialog"
                                data-analytics={ label }
                            >
                                { IconComponent ? (
                                    <span className="start-page-menu__icon"><IconComponent /></span>
                                ) : null}
                                <span>{ label }</span>
                            </button>
                        </li>
                    ) : null;
                }) }
            </ul>

            { modalData ? (
                <Modal 
                    data={ modalData.data }
                    icon={ modalData.icon } 
                    isOpen={ true }
                    onCloseModal={ onCloseModal }
                />
            ) : null }
        </>
    );
}

export default StartPageMenu;

const resolveIcon = (type) => {
    switch(type) {
        case 'toilet':
            return ToiletIcon;
        case 'elevator':
            return ElevatorIcon;
        case 'closet':
            return ClosetIcon;
        case 'restaurant':
            return ResturantIcon;
        default:
            return null;
    }
}